/* tslint:disable */
/* eslint-disable */
/**
 * Nightingale API
 *  ### Welcome to the Nightingale API !   To use the Nightingale API, you will need a `access_token` from **Bridgetech Support**  ## How to use swagger documentation   Click `Authorize` and paste your  `access_token` as `bearerAuth`  ## Design Notes 1. For non-mandatory fields, the API will allow you to submit `null` *or* omit fields entirely. 2. All query parameters are optional. Pagination fields default as follows: * page = 1 * limit = 20
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAudits200ResponseLinks
 */
export interface GetAudits200ResponseLinks {
    /**
     * 
     * @type {string}
     * @memberof GetAudits200ResponseLinks
     */
    first?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAudits200ResponseLinks
     */
    last?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAudits200ResponseLinks
     */
    prev?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAudits200ResponseLinks
     */
    next?: string | null;
}

/**
 * Check if a given object implements the GetAudits200ResponseLinks interface.
 */
export function instanceOfGetAudits200ResponseLinks(value: object): value is GetAudits200ResponseLinks {
    return true;
}

export function GetAudits200ResponseLinksFromJSON(json: any): GetAudits200ResponseLinks {
    return GetAudits200ResponseLinksFromJSONTyped(json, false);
}

export function GetAudits200ResponseLinksFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAudits200ResponseLinks {
    if (json == null) {
        return json;
    }
    return {
        
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'prev': json['prev'] == null ? undefined : json['prev'],
        'next': json['next'] == null ? undefined : json['next'],
    };
}

export function GetAudits200ResponseLinksToJSON(json: any): GetAudits200ResponseLinks {
    return GetAudits200ResponseLinksToJSONTyped(json, false);
}

export function GetAudits200ResponseLinksToJSONTyped(value?: GetAudits200ResponseLinks | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first': value['first'],
        'last': value['last'],
        'prev': value['prev'],
        'next': value['next'],
    };
}

